import { Volume2, VolumeX } from 'lucide-react';
import { useHudToggles } from '@/hooks/useGameStore';

export function GameHud() {
  const { audioEnabled, toggleAudio } = useHudToggles();

  return (
    <header className="flex justify-end p-5">
      <button
        type="button"
        onClick={toggleAudio}
        aria-label={audioEnabled ? 'Desactivar audio' : 'Activar audio'}
        title={audioEnabled ? 'Audio activo' : 'Audio apagado'}
        className="pointer-events-auto grid h-[76px] w-[76px] place-items-center rounded-lg border border-white/20 bg-[#163a24]/80 text-white shadow-hud backdrop-blur-md transition hover:bg-[#23502f]"
      >
        {audioEnabled ? <Volume2 className="h-9 w-9" /> : <VolumeX className="h-9 w-9" />}
      </button>
    </header>
  );
}
